import React, { useState, useEffect, useRef } from 'react';
import './ScrollToTopButton.css';
import { FaArrowUp } from 'react-icons/fa';

const SHOW_THRESHOLD = 500;
const HIDE_THRESHOLD = 100;
const HIDE_DELAY_MS = 500;

function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);
  const visibleRef = useRef(false);
  const rafRef = useRef(null);
  const hideTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      rafRef.current = requestAnimationFrame(() => {
        const y = window.scrollY;
        if (y > SHOW_THRESHOLD) {
          if (hideTimeoutRef.current) {
            clearTimeout(hideTimeoutRef.current);
            hideTimeoutRef.current = null;
          }
          if (!visibleRef.current) {
            visibleRef.current = true;
            setVisible(true);
          }
        } else if (y < HIDE_THRESHOLD && visibleRef.current) {
          if (!hideTimeoutRef.current) {
            hideTimeoutRef.current = setTimeout(() => {
              visibleRef.current = false;
              setVisible(false);
              hideTimeoutRef.current = null;
            }, HIDE_DELAY_MS);
          }
        } else if (y > HIDE_THRESHOLD && hideTimeoutRef.current) {
          clearTimeout(hideTimeoutRef.current);
          hideTimeoutRef.current = null;
        }
        rafRef.current = null;
      });
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      className={`scroll-to-top ${visible ? 'visible' : ''}`}
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <FaArrowUp />
    </button>
  );
}

export default ScrollToTopButton;